(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('ProvisioningController', ProvisioningController);

    ProvisioningController.$inject = ['$scope', '$state', '$rootScope'];

    function ProvisioningController($scope, $state, $rootScope) {

        $scope.$on('newDataFilter', function (event, data) {
            $scope.$broadcast('eventFilter', data);
        });

        $scope.$on('newClearFilter', function (data) {
            $scope.$broadcast('clearFilter', data);
        });

    }
})();